import React, { FC } from 'react';
import { ComponentRendering, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import useMediaQuery from '../../../hooks/useMediaQuery';
import { findCtaType } from '../../../utils/popUpCtaType.utils';
import CTA from '../../@shared/CTA';
import Breakpoints from '../../../constants/breakpoints.constants';
import { targetLinkdsk } from '../../../utils/targetDskLink';
import ctaTypes from '../../../enums/CTA.enums';
import { TUserExperienceButtons } from '../types/userExperience.types';

const UserExperienceButtons: FC<TUserExperienceButtons> = (props) => {
  const { button1, button2, rendering } = props;
  const hasSecondaryCta = button2?.text && button2?.href;
  const popUpCtaType = findCtaType(props?.rendering);
  const primaryCTAclassName = !hasSecondaryCta && popUpCtaType === 'primary-cta' ? 'text-module__margin' : '';
  const secondaryCTAclassName = popUpCtaType === 'primary-cta' ? 'user-experience__mr' : '';
  const isDesktop = useMediaQuery(`(min-width: ${Breakpoints['tbl-p']}px)`);
  return (
    <div className={'user-experience__buttons'}>
      {button1?.text && button1?.href && (
        <CTA
          type={ctaTypes.primaryOrange}
          href={button1.href}
          target={targetLinkdsk({ value: { href: button1?.href, target: button1?.target } }, isDesktop)}
          extraClassName={primaryCTAclassName}
        >
          {button1.text}
        </CTA>
      )}
      {hasSecondaryCta && (
        <CTA
          type={ctaTypes.secondaryBlack}
          href={button2?.href}
          target={targetLinkdsk({ value: { href: button2?.href, target: button2?.target } }, isDesktop)}
          extraClassName={secondaryCTAclassName}
        >
          {button2?.text}
        </CTA>
      )}
      <div className="user-experience__pop-up">
        <Placeholder name={'jss-generic-popup'} rendering={rendering as ComponentRendering} />
      </div>
    </div>
  );
};

export default UserExperienceButtons;
